import { render, staticRenderFns } from "./cremainder.vue?vue&type=template&id=5d6e13ea&scoped=true&"
import script from "./cremainder.vue?vue&type=script&lang=js&"
export * from "./cremainder.vue?vue&type=script&lang=js&"
import style0 from "./cremainder.vue?vue&type=style&index=0&id=5d6e13ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6e13ea",
  null
  
)

export default component.exports